
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";

const VisionPage = () => {
  const navigate = useNavigate();
  
  const { data: images } = useQuery({
    queryKey: ["images", "vision"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "vision")
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data;
    },
  });

  const handleNavigateBack = () => {
    navigate(-1);
    setTimeout(() => {
      const section = document.getElementById('ns3');
      if (section) {
        const offset = -80;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset + offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, 100);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getImageUrl = () => {
    if (images && images.length > 0) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(images[0].storage_path);
      return data.publicUrl;
    }
    return '/lovable-uploads/92a6f9e3-e2e7-456c-ba7c-1d11f789d7b0.png';
  };

  const experiences = [
    {
      title: "FAKTENBASIERTE HANDLUNGSEMPFEHLUNGEN",
      content: "Als Strategieberater ist es mein täglich Brot, faktenbasiert Handlungsempfehlungen zu geben. Das nutze ich im Coaching von dir, um auf Basis deiner Leidenschaften, Stärken und Schwächen sowie der Bedarfe und Berufsoptionen, faktenbasiert, kühl und nüchtern klare Entscheidungsoptionen mit dir zu erarbeiten samt allen Vor- und Nachteilen",
      borderColor: "border-[#D3E4FD]"
    },
    {
      title: "EMPATHIE UND VERSTÄNDNIS",
      content: "Von meiner Erfahrung als Pfarrer profitierst du, indem ich deine Situation, Persönlichkeit und auch Probleme warmherzig, empathisch und verständnisvoll wahrnehme.",
      borderColor: "border-[#F2FCE2]"
    },
    {
      title: "KREATIVE METHODEN",
      content: "Durch meine Jugendarbeit, unzählige Konfirmanden-Wochenenden und Workshoptätigkeit als Berater profitierst du, indem ich mit dir nicht langweilig, sondern kreativ deine berufliche Orientierung vorantreibe.",
      borderColor: "border-[#FFDEE2]"
    },
    {
      title: "KONSEQUENTE UMSETZUNG",
      content: "Wie ich als Berater Projekte zur Umsetzung vorantreibe auf Basis eines Meilensteinplans, so werde ich auch mit dir die notwendigen Schritte deines Weges, für den du dich entscheidest, begleiten und vorantreiben, damit du auch dort ankommst, wo du gerne hin willst.",
      borderColor: "border-[#FDE1D3]"
    },
    {
      title: "ARBEIT & SPAß",
      content: "Und last but not least würden sicherlich 90% aller meiner ehemaligen Konfirmanden bestätigen, dass es ihnen mit mir sehr viel Spaß gemacht hat und das kann ich auch dir für unser Coaching versprechen. Das heißt nicht, dass es nicht auch anstrengend für dich sein wird (auch das können dir meine Konfis bestätigen), aber es bedeutet, dass dir unsere gemeinsame Zeit Freude machen wird.",
      borderColor: "border-[#FEF7CD]"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#243949] to-[#517fa4]">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <Button 
            variant="ghost" 
            className="text-white hover:bg-white/10 p-2 h-auto group"
            onClick={handleNavigateBack}
          >
            <div className="flex items-center animate-horizontal-bounce">
              <ChevronLeft className="w-4 h-4" />
              <ChevronLeft className="w-4 h-4 -ml-2" />
            </div>
          </Button>
          
          <h2 className="text-lg md:text-xl font-bold text-white text-center uppercase flex-grow">
            Einzigartige Kombi
          </h2>
          
          <div className="w-[40px]"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="aspect-[21/9] w-full mb-8 bg-white rounded-lg border border-[#9F9EA1] overflow-hidden">
            <img
              src={getImageUrl()}
              alt="Einzigartige Kombi"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {experiences.map((experience, index) => (
              <Card 
                key={index}
                className="bg-white/10 backdrop-blur-sm border-2 hover:border-white/40 transition-all duration-300"
              >
                <CardContent className="p-6">
                  <h3 className="text-base font-semibold text-white mb-3 uppercase text-center">
                    {experience.title}
                  </h3>
                  <p className="text-white/90 text-base leading-relaxed text-left">
                    {experience.content}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="flex justify-center mt-8">
            <Button 
              variant="ghost" 
              className="text-white hover:bg-white/10 p-2 h-auto group"
              onClick={handleNavigateBack}
            >
              <div className="flex items-center animate-horizontal-bounce">
                <ChevronLeft className="w-4 h-4" />
                <ChevronLeft className="w-4 h-4 -ml-2" />
              </div>
              <span className="ml-2">Zurück</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionPage;
